import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { RouterModule } from '@angular/router';
import { environment } from '@env/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpinterceptorService } from './core/helper/interceptor.service';
import { LoadingModule } from './shared/loading/loading.module';
import { ConfirmUserComponent } from './feature/confirm-user/confirm-user.component';
import { ProductinformationComponent } from './feature/productinformation/productinformation.component';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductinformationModule } from './feature/productinformation/productinformation.component.module';
import { MaintenanceComponent } from './feature/maintenance/maintenance.component';
import { MaintenanceModule } from './feature/maintenance/maintenance.component.module';

@NgModule({
  declarations: [
    AppComponent,
    ConfirmUserComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    LoadingModule,
    MatSelectModule,
    MatFormFieldModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatNativeDateModule,
    FormsModule,
    ReactiveFormsModule,
    ProductinformationModule,
    MaintenanceModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  exports: [
    RouterModule],
  providers: [DatePipe,
    {
      provide: HTTP_INTERCEPTORS, useClass: HttpinterceptorService, multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
